<div id="content" class="without-subnavbar allcp-form" ng-controller="AccountController">
    <div ng-include="'modules/company/menus/setting_menu.html'"></div>
    <div class="panel-body">
        <form class="form-horizontal" ng-submit="updatePassword()">
            <h5>Change Password</h5>
            <hr>
            <div class="col-md-8">

                <div class="form-group floating">
                    <input type="password" placeholder="******" class="form-control input-md" ng-model="password.old_password">
                    <label>Old Password</label>
                </div>

                <div class="form-group floating">
                    <input type="password" placeholder="******" class="form-control input-md" ng-model="password.new_password">
                    <label>New Password</label>
                </div>

                <div class="form-group floating">
                    <input type="password" placeholder="******" class="form-control input-md" ng-model="password.new_password_repeat">
                    <label>New Password (Repeat)</label>
                </div>

                <div class="form-group row">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-primary">Change Password</button>
                    </div>
                </div>

            </div>
        </form>
    </div>
</div>
